import React from 'react'
import qs from 'query-string'
import { Dropdown, NavDropdown } from 'react-bootstrap'
import { useAuth0 } from "@auth0/auth0-react"

import { constructRedirectUri } from 'modules/utils'

import { NavLinkContainer } from './NavLinkContainer'
import { LogoutButton } from './LogoutButton'
import { LoginButton } from './LoginButton'
import { SignUpButton } from './SignupButton'

type HeaderNavigationDropDownProps = {
  isAdmin: boolean,
  saveAppState: any,
  search: any,
  email?: string | undefined,
  phone?: string | undefined,
  show?: boolean,
  showDropdown?: Function,
  hideDropdown?: Function,
  className?: string,
  profileAuth0?: any,
  initialUrlParams?: any,
  site?: string,
}

export const HeaderNavigationDropDown = ({ profileAuth0, className = '', isAdmin, saveAppState, search, email, phone, show, showDropdown, hideDropdown, initialUrlParams = {}, site }: HeaderNavigationDropDownProps) => {
  const { isAuthenticated, user } = useAuth0()
  const {
    nickname,
    name = ''
  } = user || { nickname: [''], name: '' }
  const redirectUri = constructRedirectUri(qs.parse(search), location.pathname)
  const loggedInWithPhone = profileAuth0?.sub.startsWith('sms|')

  return (
    <NavDropdown
      show={show}
      id="login-menu"
      className={`avatar-box ${className}`}
      align={'end'}
      title={
        <>
        <span className={loggedInWithPhone ? 'avatar-box-text-phone' : 'avatar-box-text'}>
          {
            user ? (
              <span>{(loggedInWithPhone ? name.substring(name.length - 4) : ( nickname ? nickname[0] : '')).toUpperCase()}</span>
            ) : (
              <span className="fa fa-user helpme-icon-user" style={{width: '100%'}} />
            )
          }
        </span>
        <span className="caret"></span>
        </>
      }
      {...(showDropdown && hideDropdown ? {
        onMouseEnter: () => showDropdown('login'),
        onMouseLeave: () => hideDropdown('login')
      } : null)}
    >
      { isAuthenticated ? <Dropdown.Item><span style={{ cursor: 'default'}}>{`Logged in as: ${(name || '').toUpperCase()}`}</span></Dropdown.Item> : null }
      {
        (isAuthenticated && isAdmin) ? (
          <Dropdown.Item>
            <NavLinkContainer to="/admin" onClick={() => { return }}>
              Admin Zone
            </NavLinkContainer>
          </Dropdown.Item>
        ) : null
      }
      { 
        isAuthenticated ? 
        <LogoutButton saveAppState={saveAppState} redirectUri={redirectUri} initialUrlParams={initialUrlParams} /> : 
        <>
          <LoginButton saveAppState={saveAppState} email={email} redirectUri={redirectUri} initialUrlParams={initialUrlParams} /> 
          {/* <LoginButton saveAppState={saveAppState} phone={phone} redirectUri={redirectUri} sms={true} /> */}
        </>
      }
      { isAuthenticated || site === 'STS' ? null : <SignUpButton saveAppState={saveAppState} email={email} redirectUri={redirectUri} initialUrlParams={initialUrlParams} /> }
    </NavDropdown>
  )
}